import SuperRepository from '../superRepository'

export default new (class metashipAccountRepository extends SuperRepository {
  baseUri() {
    return 'metaship_account'
  }
  synchronizeMetashipShops = async id =>
    this.httpClient().get(`${this.baseUri()}/${id}/synchronize`)
})()
